import {prefix} from 'inline-style-prefixer';

export default prefix;
